import { getKcContext } from 'keycloakify'
import './kcMessagesExtension'

export const { kcContext } = getKcContext<{
  pageId: 'register.ftl'
  /**
   * Defined when you use the keycloak-mail-whitelisting keycloak plugin
   * (https://github.com/micedre/keycloak-mail-whitelisting)
   */
  authorizedMailDomains: string[]
}>({
  /* Uncomment to test */
  // mockPageId: 'register.ftl',
  // mockPageId: 'login.ftl',
  // mockPageId: 'login-update-password.ftl',
  // mockPageId: 'login-reset-password.ftl',
  // mockPageId: 'info.ftl',
  // mockPageId: 'error.ftl',
  // mockPageId: 'terms.ftl',
  // mockPageId: 'login-verify-email.ftl',
  /**
   * Customize the simulated kcContext that will let us
   * dev the page outside keycloak (with auto-reload)
   */
  mockData: [
    {
      pageId: 'register.ftl',
      authorizedMailDomains: [
        'example.com',
        'another-example.com',
        '*.yet-another-example.com',
        '*.example.com',
        'hello-world.com',
      ],
    },
  ],
})

export type KcContext = NonNullable<typeof kcContext>
